import MyPageMenuItem from './MyPageMenuItem';

const MyPageMenuList = ({
  items
}: {
  items: { title: string; path: string; onClick?: () => void }[];
}) => {
  return (
    <div>
      {items.map((item, index) => {
        const isLastItem = index === items.length - 1;
        return (
          <MyPageMenuItem
            key={item.title}
            item={item}
            isLastItem={isLastItem}
            onClick={item.onClick}
          />
        );
      })}
    </div>
  );
};

export default MyPageMenuList;
  
